import { render, staticRenderFns } from "./subtitles.vue?vue&type=template&id=2e114534&scoped=true&"
import script from "./subtitles.ts?vue&type=script&lang=js&"
export * from "./subtitles.ts?vue&type=script&lang=js&"
import style0 from "./subtitles.less?vue&type=style&index=0&id=2e114534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e114534",
  null
  
)

export default component.exports